import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDeepnoteComponent } from './simple-icons-deepnote.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDeepnoteComponent ],
    exports:      [ SimpleIconsDeepnoteComponent ],
    bootstrap:    []
})
export class SimpleIconsDeepnoteModule {}
